import React, { Component } from 'react';
import { Trans } from 'react-i18next';

class Footer extends Component {
    render () {
        return (
            <footer className="footer">
                <div className="container-fluid">
                    <div className="d-sm-flex justify-content-center justify-content-sm-between">
                        <span className="text-muted text-center text-sm-left d-block d-sm-inline-block"><Trans>Copyright</Trans> ©{(new Date()).getFullYear()} <a href="http://www.aegeanoil.com/" target="_blank" rel="noopener noreferrer">AEGEAN Oil</a></span>
                        <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"><Trans>Powered by b-anywhere</Trans></span>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;